export default __webpack_public_path__ + "mobile_02-7667e9228a551f6aa6bdacc43b103a7c.jpg";